import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { useLocation } from 'react-use'
import { AnimatePresence } from 'framer-motion'
import { Toaster } from 'react-hot-toast'

import MainScreen from '../../screens/MainScreen'
import UseAppScreen from '../../screens/UseAppScreen'
import NovelScreen from '../../screens/NovelScreen'
import ToonScreen from '../../screens/ToonScreen'
import ToonDetailScreen from '../../screens/ToonDetailScreen'
import NovelDetailScreen from '../../screens/NovelDetailScreen'
import EventScreen from '../../screens/EventScreen'
import EventListScreen from '../../screens/EventListScreen'
import ToonReaderScreen from '../../screens/ToonReaderScreen'
import NudgeBottomsheet from './nudgeBottomSheet'
import NudgeBanner from './nudgeBanner'

const routes = [
  {
    path: '/',
    exact: true,
    element: <MainScreen />,
  },
  {
    path: '/novel',
    exact: true,
    element: <UseAppScreen />,
    // element: <NovelScreen />,
  },
  {
    path: '/novel-detail/:novelId',
    exact: true,
    element: <NovelDetailScreen />,
  },
  {
    path: '/toon',
    exact: true,
    element: <ToonScreen />,
  },
  {
    path: '/toon-detail/:toonId',
    exact: true,
    element: <ToonDetailScreen />,
  },
  {
    path: '/toon-reader/:chapterId',
    exact: true,
    element: <ToonReaderScreen />,
  },
  {
    path: '/mypage',
    exact: true,
    element: <UseAppScreen />,
  },
  {
    path: '/mission',
    exact: true,
    element: <UseAppScreen />,
  },
  {
    path: '/event/:eventId',
    exact: true,
    element: <EventScreen />,
  },
  {
    path: '/event-list',
    exact: true,
    element: <EventListScreen />,
  },
]

const StackNavigator = () => {
  const location = useLocation()
  return (
    <AnimatePresence>
      <BrowserRouter>
        <Routes location={location}>
          {routes.map((route, index) => (
            <Route
              key={route.path}
              exact={route?.exact}
              path={route.path}
              element={route.element}
            />
          ))}
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              marginTop: '24vw',
              color: '#965F42',
            },
          }}
        />
        <NudgeBanner />
        <NudgeBottomsheet />
      </BrowserRouter>
    </AnimatePresence>
  )
}

export default StackNavigator
